import { SystemResource } from "src/pages/information-assets/models/system-resources";
import { AppliedScope } from "./../../../models/current-applied-scopes";

export class SystemResourceTableRecord {
  systemResourceId: String;
  systemId: String;
  name: String;
  owners: String[] | null;
  createdOn: string;
  attributes: Record<string, string>;
  individualUsersAdded: String[];
  groups: String[];
  dataAvailableAt: string | null;
  currentAppliedScopes: string[];

  constructor(
    systemResource: SystemResource,
    individualUsersAdded: String[],
    groups: String[],
    resourceId: String,
    currentAppliedScopes: AppliedScope[]
  ) {
    this.systemId = systemResource.system.id;
    this.systemResourceId = systemResource.systemResourceId;
    this.name = systemResource.name;
    this.createdOn = systemResource.createdOn;
    this.owners = systemResource.owners.map((owner) => owner.email);
    this.attributes = systemResource.attributes;
    this.individualUsersAdded = individualUsersAdded;
    this.groups = groups;
    this.dataAvailableAt = systemResource.dataAvailableAt(resourceId);
    this.currentAppliedScopes = currentAppliedScopes.map((appliedScope) =>
      appliedScope.displayFormat()
    );
  }

  isAssociatedToGroup(searchedGroup: string): boolean {
    return this.groups.some((group) => group === searchedGroup);
  }
}
